var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLogOutSml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "58px",
    viewBox: "0 0 49 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon log out") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "log-out",
    transform: "translate(-134.000000, -173.000000)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-log-out",
    transform: "translate(135.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    stroke: "#949494",
    points: "24.2162162 56 0 56 0 0 24.2162162 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4594595,56 L0,56 L0,0 L23.4594595,0",
    stroke: "#949494",
    strokeDasharray: 5,
    transform: "translate(11.729730, 28.000000) scale(-1, 1) translate(-11.729730, -28.000000) "
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.716216, 27.500000) rotate(-270.000000) translate(-28.716216, -27.500000) translate(18.000000, 10.000000)",
    stroke: "#0091DA"
  }, /*#__PURE__*/React.createElement("polyline", {
    transform: "translate(10.716216, 6.603774) rotate(-90.000000) translate(-10.716216, -6.603774) ",
    points: "4.11244263 -4.11244263 17.3199898 6.60377358 4.11244263 17.3199898"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11.0058437,
    y1: 0.660377358,
    x2: 11.0058437,
    y2: 35,
    strokeLinecap: "square"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLogOutSml);
export default __webpack_public_path__ + "static/media/icon_log_out_sml.3b78349df50c81aa5538a6a047f92e2f.svg";
export { ForwardRef as ReactComponent };